import { point } from '../elements';
import type { NodeData } from '../nodes/types';
import type { EdgePositions } from './EdgePositions';
import { getEdgeBetweenNodesPositions } from './getEdgeBetweenNodesPositions';
import { getLoopbackEdgePositions } from './getLoopbackEdgePositions';
import type { EdgeDataForPositions } from './positions';

export function getEdgePositions(
  source: NodeData,
  target: NodeData,
  edgeData: EdgeDataForPositions,
): EdgePositions | null {
  if (
    source.id === target.id &&
    point.equals(source.position, target.position)
  ) {
    return getLoopbackEdgePositions(source, edgeData);
  }
  return getEdgeBetweenNodesPositions(source, target, edgeData);
}
